import { makeStyles } from '@material-ui/core';
import hexToRgb from '../../../helpers/ui/coloringHelper';

const useStyles = makeStyles((theme) => ({
  withChildrenBlock: {
    padding: 14,
    fontSize: 16,
    backgroundColor: `rgba(${hexToRgb(theme.palette.blue.efesLightBlue)}, 0.03)`,
    borderRadius: 10,
    [theme.breakpoints.down(490)]: {
      fontSize: 12,
      padding: 10,

    },
    [theme.breakpoints.down(390)]: {
      fontSize: 10,
    },
    [theme.breakpoints.down(390)]: {
      fontSize: 9,
    },
  },
  sectionRow: {
    padding: '25px 0',
    [theme.breakpoints.down('lg')]: {
      padding: '16px 0',
    },
  },
  paymentFrequenciesWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 0',
    [theme.breakpoints.down('lg')]: {
      padding: '16px 0',
    },
  },
  sectionTitle: {
    fontSize: 20,
    [theme.breakpoints.down('lg')]: {
      fontSize: 16,
    },
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  mobileTitle: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

export default useStyles;
